import { ProfileType } from "../types/enum";

export const hasMyobPlanAccess = (currentProfile, billingAccess) =>
    !!billingAccess?.isProPlan ||
    (currentProfile?.type === ProfileType.Musician.ordinal && !!billingAccess?.isBasicPlan);